import type {Mark} from "@tiptap/pm/model";
import type {CSSProperties} from "react";
import {getVariableChipStyle} from "../../common/variables/variableChipStyles";

// Editor-only formatting layered over the shared variable-chip style.
const BOLD_CHIP_INK = "#3B0764";

const hasMark = (marks: readonly Mark[], markName: string) => (
    marks.some(mark => mark.type.name === markName)
);

export const getPrintoutVariableChipStyle = (
    marks: readonly Mark[],
    {editable}: {editable: boolean},
): CSSProperties => {
    const style: CSSProperties = {...getVariableChipStyle(marks)};

    if (!editable) return style;

    if (hasMark(marks, "bold")) {
        style.WebkitTextStroke = "0.35px currentColor";
        if (!hasMark(marks, "textStyle")) style.color = BOLD_CHIP_INK;
    }

    if (hasMark(marks, "underline")) {
        style.textUnderlineOffset = "0.16em";
    }

    return style;
};
